
import { assign } from 'lodash';
import { updateArray } from "../../../helpers/index";
import { ActionType, IAction } from '../actions/actions';
import { IFilter } from '../../../classes/filter';
import { IMediaGalleryFilterResponse, IMediaGalleryItem } from '../../../classes/media-gallery';

export interface MediaApiModel {
    /**
     * If this is true, media is currently being loaded.
     */
    requestingMedia: boolean;
    /**
     * Replace with media response interface.
     */
    mediaList: IMediaGalleryItem[];
    filteredMediaList: IMediaGalleryItem[];
    /**
     * If there is no more media in the API, this will be set to true.
     */
    noMoreMedia: boolean;
    currentBatch: number;
    requestingFilters: boolean;
    filters: IMediaGalleryFilterResponse;
};

export const defaultMediaApiModel: MediaApiModel = {
    requestingMedia: false,
    mediaList: [],
    noMoreMedia: false,
    currentBatch: 0,
    filteredMediaList: [],
    requestingFilters: false,
    filters: null
};

export default function mediaApiReducer(state: MediaApiModel = defaultMediaApiModel, action: IAction) {
    switch (action.type) {
        case ActionType.REQUEST_NEXT_BATCH: {
            return assign({}, state, { requestingMedia: true, currentBatch: state.currentBatch + 1 });
        }

        case ActionType.RECEIVE_NEXT_BATCH: {
            const medias = action.value.medias;
            const noMoreToLoad = action.value.noMoreMedia;

            const newArray = [...state.mediaList.slice(0, state.mediaList.length), ...medias];

            return assign({}, state, { requestingMedia: false, mediaList: newArray, noMoreMedia: noMoreToLoad });
        }

        case ActionType.REQUEST_FILTERS: {
            return assign({}, state, { requestingFilters: true });
        }

        case ActionType.RECEIVE_FILTERS: {
            return assign({}, state, { requestingFilters: false, filters: action.value });
        }

        case ActionType.STORE_FILTERED_MEDIA: {
            return assign({}, state, { filteredMediaList: action.value });
        }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./app/media-gallery/redux/reducers/media-api.ts